import { validationMessages } from './validationMessages.schema';

export default {
  title: 'Faktura',
  type: 'object',
  properties: {
    nip: {
      fieldRequired: true,
      format: 'nip',
      title: 'NIP wystawcy',
      type: 'string',
      validationMessages: {
        format: 'Błąd: Nieprawidłowy numer NIP.'
      }
    },
    date: {
      fieldRequired: true,
      format: 'date',
      title: 'Data wystawienia',
      type: 'string',
      validationMessages: {
        validFunc: 'Data faktury musi pokrywać się z okresami wypłat na podstawie faktur.'
      },
      validFunc: [
        'if (',
        '  !$external.document ||',
        '  !$external.document.currentDecision ||',
        '  !$external.document.currentDecision.dateRanges ||',
        '  !$external.document.currentDecision.dateRanges.length',
        ') {',
        '  return true;',
        '}',
        'var momentDate = $methods.moment($value);',
        'return $external.document.currentDecision.dateRanges',
        '  .map((range, index, ranges) =>',
        '    Object.assign({}, range, {',
        '      endDate:',
        '        range.endDate ||',
        '        (ranges[index + 1] && ranges[index + 1].endDate) ||',
        '        $external.document.currentDecision.endDate',
        '    })',
        '  )',
        '  .filter(range => range.type === "INVOICE")',
        '  .some(range => momentDate.isSameOrAfter(range.startDate) && momentDate.isSameOrBefore(range.endDate));'
      ]
    },
    number: {
      title: 'Numer faktury',
      type: 'string',
      fieldRequired: true,
      validFunc: [
        'if (!this.number || !this.date || !this.nip) {',
        '  return true;',
        '}',
        'for (var invoice of $external.otherInvoices) {',
        '  if (invoice.number === this.number && invoice.date === this.date && invoice.nip === this.nip) {',
        '    return "Błąd: Została już wprowadzona faktura o tych samych danych.";',
        '  }',
        '}',
        'return true;'
      ]
    },
    price: {
      minimum: 0.01,
      title: 'Kwota faktury',
      type: 'number',
      fieldRequired: true,
      validationMessages: {
        minimum: 'Kwota musi być większa od 0 zł.'
      }
    },
    priceToPay: {
      title: 'Kwota podlegająca refundacji',
      type: 'number',
      fieldRequired: true,
      maximum: 'this.price',
      minimum: 0.01,
      warnings: {
        maximum: '$methods.mround($external.maxToPay)',
        warningMessages: {
          maximum: 'Uwaga: Kwota dotacji na bieżący rok szkolny zostanie przekroczona.'
        }
      },
      validationMessages: {
        minimum: 'Kwota musi być większa od 0 zł.'
      }
    }
  },
  allOf: [validationMessages]
};
